// src/pages/quotation/QuotationA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { formatCurrency } from '../../utils/orderCalculations';
import { getImageUrl } from '../../utils/imageUtils';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';

const QuotationA4Document = ({ quotation }) => {
  const { t } = useLocalization();

  if (!quotation) return null;

  const itemsTotal = (quotation.items || []).reduce((sum, item) => sum + parseFloat(item.lineTotal || 0), 0);

  return (
    <A4DocumentLayout
      title={quotation.Shop?.name || 'STORE'}
      logoUrl={getImageUrl(quotation.Shop?.logo)}
      subtitle={t('quotation.officialQuotation', 'Official Quotation')}
      documentNumber={`#${quotation.quotationNumber}`}
      metaRows={[
        { label: t('common.created'), value: new Date(quotation.createdAt).toLocaleString() },
        { label: t('common.status'), value: (quotation.status || '').toUpperCase() },
      ]}
      infoCards={[
        {
          title: t('quotation.customer'),
          primary: quotation.customer?.name || quotation.prospectName || t('common.na'),
          lines: [{ label: t('quotation.customerPhone'), value: quotation.customer?.phone || quotation.prospectPhone || t('common.na') }],
        },
        {
          title: t('quotation.quotationNumber'),
          lines: [
            { label: t('quotation.shop'), value: quotation.Shop?.name || t('common.na'), bold: true },
            { label: t('quotation.validUntil'), value: quotation.validUntil ? new Date(quotation.validUntil).toLocaleDateString() : t('common.na'), bold: true },
          ],
        },
      ]}
      items={{
        columns: [
          { header: '#', align: 'center', width: '40px' },
          { header: t('quotation.items') },
          { header: t('quotation.unitPrice'), align: 'right' },
          { header: t('quotation.quantity'), align: 'center' },
          { header: t('quotation.lineDiscount'), align: 'right' },
          { header: t('quotation.lineTotal'), align: 'right' },
        ],
        rows: (quotation.items || []).map((item, index) => [
          index + 1,
          <strong>{item.Product?.name || item.displayName || t('common.na')}</strong>,
          formatCurrency(item.unitPrice),
          item.quantity,
          formatCurrency(item.lineDiscount || 0),
          <strong>{formatCurrency(item.lineTotal)}</strong>,
        ]),
      }}
      summary={{
        notes: { label: t('quotation.notes'), text: quotation.notes || t('common.none', 'None') },
        totals: [{ label: t('quotation.total'), value: formatCurrency(itemsTotal), variant: 'grand' }],
      }}
      footerText={t('quotation.thankYouMessage', 'Thank you for your business!')}
      footerNote="This is a computer-generated quotation."
    />
  );
};

export default QuotationA4Document;
